import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { hasGlobalFeature } from 'selectors';
import { routes } from 'constants/config';
import useFeatureFlags from 'hooks/useFeatureFlags';
import Layout from '../shared/Layout';
import Loading from '../shared/Loading';
import Sidebar from './Sidebar';
import Assignments from './Assignments';
import MyContent from './MyContent';
import Topic from './Topic';
import History from './History';
import SpotlightsHomePage from './Spotlights';

const Content = ({
  hasFeatureChangeAssignmentsToResources,
  hasAskTheExpert,
}) => {
  const hasUnificationFeatureFlag = useFeatureFlags(
    'readiness-enable-unification',
  );

  const isUnifiedLearn2 = useFeatureFlags([
    'readiness-enable-unification',
    'readiness-enable-learn2',
  ]);

  return (
    <Layout.Main>
      <Loading>
        {!isUnifiedLearn2 && (
          <Layout.Side
            className={classNames({
              UnificationSearchBar: hasUnificationFeatureFlag,
              'UnificationSearchBar-expertOffset':
                hasUnificationFeatureFlag && hasAskTheExpert,
            })}
          >
            <Sidebar />
          </Layout.Side>
        )}
        <Layout.Content>
          <Switch>
            <Route
              path={
                hasFeatureChangeAssignmentsToResources
                  ? routes.LEARN_RESOURCES
                  : routes.LEARN_ASSIGNMENTS
              }
              component={Assignments}
            />
            <Route path={routes.LEARN_TOPIC} component={Topic} />
            <Route path={routes.LEARN_HISTORY} component={History} />
            <Route
              path={routes.LEARN_SPOTLIGHTS}
              component={SpotlightsHomePage}
            />

            <Route component={MyContent} />
          </Switch>
        </Layout.Content>
      </Loading>
    </Layout.Main>
  );
};

const mapStateToProps = state => ({
  hasFeatureChangeAssignmentsToResources: hasGlobalFeature(
    state,
    'change_assignments_to_resources',
  ),
  hasAskTheExpert: !!state.meta.askTheExpert.expert,
});

export default connect(mapStateToProps)(Content);
